import React, { useState } from 'react';
import {
  Box,
  Button,
  IconButton,
  Stack,
  TextField,
  Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import RadarIcon from '@mui/icons-material/Radar';
import { useContactUpdate } from '../../../hooks/useContactUpdate';
import { contactDetailStyles, animations } from './styles';

const ContactOpportunityContext = ({ contact, onContactUpdate }) => {
  const { updateContactPartial } = useContactUpdate();
  const [editing, setEditing] = useState(false);
  const [formData, setFormData] = useState({
    whereWeMet: contact.whereWeMet || '',
    rememberMeFor: contact.opportunityContext?.rememberMeFor || '',
    canIntroduceTo: contact.opportunityContext?.canIntroduceTo || ''
  });

  const updateField = (field) => (event) => {
    setFormData((current) => ({ ...current, [field]: event.target.value }));
  };

  const handleSave = async () => {
    const updatedContact = await updateContactPartial(contact._id, {
      whereWeMet: formData.whereWeMet,
      opportunityContext: {
        ...(contact.opportunityContext || {}),
        rememberMeFor: formData.rememberMeFor,
        canIntroduceTo: formData.canIntroduceTo
      }
    }, contact);

    onContactUpdate(updatedContact);
    setEditing(false);
  };

  const hasContext = contact.whereWeMet ||
    contact.opportunityContext?.rememberMeFor || contact.opportunityContext?.canIntroduceTo;

  return (
    <Box sx={{ ...contactDetailStyles.sectionContainer, ...animations.fadeInUp }}>
      <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
        <Typography variant="h6" sx={{ ...contactDetailStyles.sectionTitle, display: 'flex', alignItems: 'center', gap: 1 }}>
          <RadarIcon fontSize="small" />
          Opportunity context
        </Typography>
        {!editing && (
          <IconButton size="small" onClick={() => setEditing(true)}>
            <EditIcon fontSize="small" />
          </IconButton>
        )}
      </Stack>

      {editing ? (
        <Box sx={contactDetailStyles.formPaper}>
          <Stack spacing={1.5}>
            <TextField label="Where we met" value={formData.whereWeMet} onChange={updateField('whereWeMet')} fullWidth />
            <TextField label="What they might remember me for" value={formData.rememberMeFor} onChange={updateField('rememberMeFor')} fullWidth />
            <TextField label="Can introduce to" value={formData.canIntroduceTo} onChange={updateField('canIntroduceTo')} fullWidth />
            <Stack direction="row" spacing={1}>
              <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSave}>Save</Button>
              <Button size="small" variant="outlined" startIcon={<CancelIcon />} onClick={() => setEditing(false)}>Cancel</Button>
            </Stack>
          </Stack>
        </Box>
      ) : (
        <Box sx={hasContext ? contactDetailStyles.listItem : contactDetailStyles.emptyState}>
          {hasContext ? (
            <Stack spacing={0.75}>
              {contact.whereWeMet && <Typography variant="body2">Met: {contact.whereWeMet}</Typography>}
              {contact.opportunityContext?.rememberMeFor && <Typography variant="body2">Remember me for: {contact.opportunityContext.rememberMeFor}</Typography>}
              {contact.opportunityContext?.canIntroduceTo && <Typography variant="body2">Can introduce to: {contact.opportunityContext.canIntroduceTo}</Typography>}
            </Stack>
          ) : (
            <Typography color="text.secondary" sx={{ fontStyle: 'italic' }}>
              No opportunity context yet
            </Typography>
          )}
        </Box>
      )}
    </Box>
  );
};

export default ContactOpportunityContext;
